/* src/app/timeline-skip/modals/skip-accepted-order-information-modal/skip-accepted-order-information-modal.component.scss */
/*# sourceMappingURL=skip-accepted-order-information-modal.component.css.map */
